<div class="top-header">
    <div class="header-content">
        <i [ngClass]="iconClass">{{iconText}}</i>
        <span class="page-title">{{title}}</span>
    </div>
</div>
